/**
 * Reads the first `cgid=<categoryId>` entry from a SCAPI-style `refine` list (PLP query / loader data).
 * Returns the category id segment, or `null` when absent or empty.
 */
export function parseCgidFromRefine(refine: string[] | null | undefined): string | null {
    if (refine == null || refine.length === 0) {
        return null;
    }
    const raw = refine.find((r) => r.startsWith('cgid='));
    if (raw == null || raw.length <= 'cgid='.length) {
        return null;
    }
    return raw.slice('cgid='.length) || null;
}

/**
 * PLP refine helpers. `parseCgidFromRefine` is used for product grid `cgid`, SEO link exclusion,
 * and PLP header copy when a subcategory is selected via `?refine=cgid=…` on the same route category.
 */
